<script>
	import { getContext, onDestroy, onMount } from 'svelte'


	const flightContext = getContext('flight')
	let flight
	export let handlerClass

	let object

	onMount(() => {
		flight = flightContext.get()
		object = flight.getHandler(handlerClass)
	})
	onDestroy(() => {
		flight.releaseHandler(handlerClass)
	})
</script>